import './reset.scss'
import './global.scss'
import { ThemeProvider } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from 'react-router-dom'

import { HolidaysLoader } from 'components/loader/HolidaysLoader'
import { GetAuthSession } from 'hooks/api/axios'
import { answerRoutes } from 'routes/answer'
import { baseRoutes } from 'routes/base'
import { securityRoutes } from 'routes/security'
import { securityFieldRoutes } from 'routes/securityField'
import { shiftRoutes } from 'routes/shift'
import { store } from 'store/store'
import { defaultTheme } from 'variables'

import SnackbarViewerComponent from './components/snackbarViewer'

import Layout from './layout'
import NotFoundPage from './notFound'

// 曜日を日本語にする
import 'dayjs/locale/ja'
dayjs.locale('ja')

const root = createRoot(document.getElementById('root') as HTMLElement)

const isAuthenticated = (): boolean => {
  const sessionKey = GetAuthSession()
  if (!!sessionKey) {
    return true
  } else {
    return false
  }
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <HolidaysLoader />
        <ThemeProvider theme={defaultTheme}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
            <Routes>
              {baseRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
              <Route path="/" element={<Outlet />}>
                {/*ログイン不要*/}
                {answerRoutes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Route>

              <Route
                path="/"
                element={
                  isAuthenticated() ? (
                    <Layout />
                  ) : (
                    <Navigate to={'/login'}></Navigate>
                  )
                }
              >
                {securityRoutes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
                {securityFieldRoutes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
                {shiftRoutes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </LocalizationProvider>
          <SnackbarViewerComponent />
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
)
